
import * as React from 'react'

interface ISystemButton {
    btnType?: any,
    className: string,
    iconName?: string,
    title: string,
    btnTitle: string,
    handleClick?: any
    disabled?: boolean
}

export const SystemButton = (props: ISystemButton) => {
    const buttonType = props.btnType || 'button';

    return (
        <button disabled={props.disabled} type={buttonType} className={['btn', props.className].join(" ")} title={props.btnTitle} onClick={props.handleClick}>
                <i className={`icon-${props.iconName}`}></i>{ props.btnTitle}
            </button>
        )
}

